import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.9y8Ox92UgFYlDrCzVJgpPf3yHupKbvWiaj1y6f1Tb1GfNPuLPuj-y3DLVgKCz3bq26q3VZYmnKvexPfPtgRE1zefNNOgy1c9QWi8RhOYo_Y-yiorXcDY1syQqFrmbDo10P_CqIWadhJUqdQmHM_aLQkzSZzrvTc7s92frO3S98iD9EKni2gm9o87UnMX6tykyf-61B35VQa40_fOVeSuOtoVZc8GAR0pxUEHkDv6oEVRpPjMrQv3Rifkqj2YCgtty8ZnpdbbG-EKr8Vk8AdZue5XmruoHy8XvVFfGNEarjQuenOMnPsVHl3TVvxBne-Ija-RsyX0Q5JvTzgWlnxDmQ35Fju0Ce75fA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-07-14T15:12:20.229351Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.9y8Ox92UgFYlDrCzVJgpPf3yHupKbvWiaj1y6f1Tb1GfNPuLPuj-y3DLVgKCz3bq26q3VZYmnKvexPfPtgRE1zefNNOgy1c9QWi8RhOYo_Y-yiorXcDY1syQqFrmbDo10P_CqIWadhJUqdQmHM_aLQkzSZzrvTc7s92frO3S98iD9EKni2gm9o87UnMX6tykyf-61B35VQa40_fOVeSuOtoVZc8GAR0pxUEHkDv6oEVRpPjMrQv3Rifkqj2YCgtty8ZnpdbbG-EKr8Vk8AdZue5XmruoHy8XvVFfGNEarjQuenOMnPsVHl3TVvxBne-Ija-RsyX0Q5JvTzgWlnxDmQ35Fju0Ce75fA'

// {
//   "access_token": "v2.local.gkg-6CPkESS-5PyPzYxVSmhQyYggnXS_7XKRSsm5CvaGMmbRVqBdcvSQ8PE_a06td34wxPB3JNcS960SFEfBTAsPK-PSP1MCaFuWN67f8qZIyAQBPGuKUKYGoQH2k4pwwanul1IPYcJmRzM9WUbt_h89ztKvlV4U_-DkjJn9X5Q8qULhXJyXwospq1l7C5EgV57n4NZylDS8dbhD-HjOl4Ub5PLm-rkQwRQb4j-W6zym3An1w-FXcx1MHEpJW0pXFpcl5Y-NdBh95aL0HKVQg8Xd8EQmc-RbW7nGBYVlcppSnsJsyEz4yLa88Mu3MvE-WCwzkUN1OChF7letu3-AgL-PVuFq",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-07-14T15:12:20.525174Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.gkg-6CPkESS-5PyPzYxVSmhQyYggnXS_7XKRSsm5CvaGMmbRVqBdcvSQ8PE_a06td34wxPB3JNcS960SFEfBTAsPK-PSP1MCaFuWN67f8qZIyAQBPGuKUKYGoQH2k4pwwanul1IPYcJmRzM9WUbt_h89ztKvlV4U_-DkjJn9X5Q8qULhXJyXwospq1l7C5EgV57n4NZylDS8dbhD-HjOl4Ub5PLm-rkQwRQb4j-W6zym3An1w-FXcx1MHEpJW0pXFpcl5Y-NdBh95aL0HKVQg8Xd8EQmc-RbW7nGBYVlcppSnsJsyEz4yLa88Mu3MvE-WCwzkUN1OChF7letu3-AgL-PVuFq'

// {
//   "access_token": "v2.local.n5S1qWOQCQc3S1vwDruxdGQ1VkgFZdHC0tDVNqLtRvHx4iU8dJqFw3w6Qbv23-GV_OHmS-bxnjrMBvZ7R_qdTpIlRdEnBotddHsHDffy6HTAFe4PAK4v4zsK17QkdEUUC5fw85_fK57G3UMMywfVFiIUShyQ53TeXyiDcEOgdEN5zF1tAO6HgFwIZYPS2HV6Qu0dEs4cMOBgz6ESt9_anAXmWw_WO_VjX0nb4wKhwJaiFxr3oL1_aofoXVWAeQgVAmhIM7FQu9I4lmsf9KWiIf_uVli5WEdZmzLMJhKZBSjXuFuTLRwvHg_dB-lpjo3Br1XiGfw8pHR0yBIkhmaFgzraBDU",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-07-14T15:12:20.881312Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.n5S1qWOQCQc3S1vwDruxdGQ1VkgFZdHC0tDVNqLtRvHx4iU8dJqFw3w6Qbv23-GV_OHmS-bxnjrMBvZ7R_qdTpIlRdEnBotddHsHDffy6HTAFe4PAK4v4zsK17QkdEUUC5fw85_fK57G3UMMywfVFiIUShyQ53TeXyiDcEOgdEN5zF1tAO6HgFwIZYPS2HV6Qu0dEs4cMOBgz6ESt9_anAXmWw_WO_VjX0nb4wKhwJaiFxr3oL1_aofoXVWAeQgVAmhIM7FQu9I4lmsf9KWiIf_uVli5WEdZmzLMJhKZBSjXuFuTLRwvHg_dB-lpjo3Br1XiGfw8pHR0yBIkhmaFgzraBDU'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
